import React, { useState, useEffect } from 'react';
import Form from '../../../adminpanel/components/commonComponents/Form.v2';
import { Redirect, Switch, Route } from 'react-router-dom';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import Register from './Register';
import ForgotWorkspace from './ForgotWorkspace';
import LoginNew from './LoginNew';

document.getElementById('SKIN_MODE').href = '/css/skin.light.css';

const LoginContainer = ({ match }) => {
	companyName = companyName ? companyName : process.env.companyName;
	const footer = [
		{
			label: 'Terms & Conditions',
			url: 'https://www.rockmetric.com/terms-of-use',
		},
		{
			label: 'Privacy Policy',
			url: 'https://www.rockmetric.com/privacy',
		},
		{
			label: 'Contact',
			url: 'https://www.rockmetric.com/#contact',
		},
	];
	var authData = localStorage['persist:root'] && JSON.parse(localStorage['persist:root'])['dataSet'] ? JSON.parse(JSON.parse(localStorage['persist:root'])['dataSet'])['authData'] : null
	if (authData || authData?.userId) {
		if (getParameters('grant_type') == 'saml' && (getParameters("code") && getParameters("state")))
		{
			var validParams = {
				companyName: getParameters("companyName"),
				grant_type: getParameters("grant_type"),
			};
			localStorage.clear();
			sessionStorage.clear();
			window.localStorage.setItem('validParams', JSON.stringify(validParams));
		} else if (getParameters('grant_type') != 'saml') {
			return (
				<Redirect to="/" />
			)
		}
	}
	if (!companyName){
		let logoName = window.location.hostname.split('.')[0];
		logo = logoNameArray.indexOf(logoName)!=-1 ? logoName : "rockmetric";
	}else logo = companyName;
	logo = logo.replace(" ","");
	setCSSComp(process.env,"all");

	let logoIMG = logo ? `/assets/images/logos/${logo}.png` : `/assets/images/logos/rockmetric.png`;

	return (
		
		<div className="container">
			<div className="row justify-content-center align-items-center ht-95v">
		<div className="col-10 col-md-7 col-lg-6 col-xl-5 pd-0 d-flex flex-column">
		{getParameters('grant_type') == 'saml' ?"" :<img
						src={logoIMG}
						alt="Logo"
						className="align-self-center mg-b-40 mg-t-40 wd-150"
					/>}
					<div
						className={getParameters('grant_type') == 'saml' ? "" : "card mg-b-20 pd-xs-x-40 pd-x-20 pd-y-30 rounded-10"}
						style={{
							boxShadow: getParameters('grant_type') == 'saml' ? "" : '0 0 10px rgba(0,0,0,0.1)',
						}}
					>
						<Switch>
							<Route exact path="/login/forgotpassword" component={ForgotPassword} />
							<Route exact path="/login/resetpassword" component={ResetPassword} />
							<Route exact path="/login/forgotworkspace" component={ForgotWorkspace} />
							<Route
								exact
								path="/login/register"
								render={(routeProps) => <LoginNew type="register" {...routeProps} />}
							/>
							<Route exact path={`${match.path}/`} render={(routeProps) => <LoginNew type="login" {...routeProps} />} />
						</Switch>
					</div>
					{/* <div className="footerContainer pd-t-20 d-flex justify-content-around">
						{footer.map((element) => (
							<a href={element.url} target="_blank">{element.label}</a>
						))}
					</div> */}
				</div>
			</div>
		</div>
	);
};

export default LoginContainer;
